import { motion } from 'framer-motion';

const Button = ({ children, variant = 'primary', className = '', ...props }) => {
    const baseStyles = "px-8 py-3 rounded-md font-medium transition-all duration-300 transform hover:-translate-y-0.5 active:translate-y-0 disabled:opacity-50 disabled:cursor-not-allowed";

    const variants = {
        primary: "bg-accent-gold text-primary-charcoal hover:bg-[#b08d55] hover:text-white shadow-lg hover:shadow-xl",
        secondary: "bg-transparent border-2 border-primary-charcoal text-primary-charcoal hover:bg-primary-charcoal hover:text-white",
        outline: "bg-transparent border border-white/30 text-white hover:bg-white hover:text-primary-charcoal backdrop-blur-sm"
    };

    return (
        <motion.button
            whileTap={{ scale: 0.98 }}
            className={`${baseStyles} ${variants[variant]} ${className}`}
            {...props}
        >
            {children}
        </motion.button>
    );
};

export default Button;
